// @flow

import { observable, action, runInAction, configure } from 'mobx';
import diplomasApi from 'api/filters/diplomas.api';
import entryAreasApi from 'api/filters/entryAreas.api';
import entryLevelsApi from 'api/filters/entryLevels.api';
import graduationsApi from 'api/filters/graduations.api';
import industriesApi from 'api/filters/industries.api';
import offersApi from 'api/filters/offers.api';
import regionsApi from 'api/filters/regions.api';
import specialitiesApi from 'api/filters/specialities.api';

configure({ enforceActions: 'observed' });

type OptionsType = Array<{
  filterPosition: number,
  id: string,
  name: string
}>;

const toOptions = (data: OptionsType, label?: string[]): Array<{ value: string, label: string }> => (
  data
    .sort((a, b) => (a.filterPosition && a.filterPosition < b.filterPosition) ? -1 : 1)
    .map(r => ({ value: r.id, label: label ? label.map(n => r[n]).join(', ') : r.name }))
);

class FiltersStore {
  @observable loading: boolean = true;
  @observable filters: any = {
    searchRegions: [],
    searchIndustries: [],
    searchDiplomas: [],
    searchGraduations: [],
    searchOffers: [],
    searchEntryLevels: [],
    searchEntryAreas: [],
    searchSpecialities: []
  };

  @action.bound
  async fetchFilters() {
    try {
      const values = await Promise.all([
        regionsApi.fetch(),
        industriesApi.fetch(),
        diplomasApi.fetch(),
        graduationsApi.fetch(),
        offersApi.fetch(),
        entryLevelsApi.fetch(),
        entryAreasApi.fetch(),
        specialitiesApi.fetch()
      ]);

      runInAction(() => {
        this.loading = false;
        this.filters = {
          searchRegions: toOptions(values[0].data),
          searchIndustries: toOptions(values[1].data),
          searchDiplomas: toOptions(values[2].data),
          searchGraduations: toOptions(values[3].data),
          searchOffers: toOptions(values[4].data),
          searchEntryLevels: toOptions(values[5].data),
          searchEntryAreas: toOptions(values[6].data),
          searchSpecialities: toOptions(values[7].data)
        };
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

export default new FiltersStore();
